import React, { Component } from 'react';
import QueryString from 'query-string';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { Col, Button, Tabs, Tab, Form } from 'react-bootstrap';

import { Http } from '../../support';
import Loading from '../../facturotopia/loading/Loading';

class Paquetes extends Component {
  state = {};

  constructor(props) {
    super(props);

    const query = QueryString.parse(this.props.location.search);

    this.state = {
      paquetes: [],
      licencia: query.licencia || 'm',
    };
  }

  componentDidMount = async () => {
    this.setState({ busy: true });

    const param = {
      params: { tag: 'hits' },
    };

    try {
      const response = await Http.get('api/paquetes', param);

      this.setState({
        busy: false,
        paquetes: response.data,
      });
    } catch (error) {
      this.setState({
        busy: false,
        error: error.data || error,
      });
    }
  };

  handleOnChange = (event) => {
    const { name, value } = event.target;

    this.setState({
      [`tipo_pago_${name}`]: value,
    });
  };

  renderItem = (item) => {
    const { id, costo_mensual, costo_anual, nombre, hits, descripcion, licencia, metadata, esquema } = item;
    const costo = licencia === 'y' ? costo_anual : costo_mensual;
    const tipoPago = this.state[`tipo_pago_${id}`] || `pago_mensual_${id}`;
    const pago_anual = tipoPago.indexOf('pago_anualizado') !== -1;
    const pago = !!pago_anual ? 'y' : 'm';

    const hitsVariable = hits === -1 ? 'ilimitados' : pago_anual ? hits * 12 : hits;
    const descripcionVariable = descripcion.replace(/^\d+\s*/, '');

    return (
      <Col
        className="py-2"
        key={item.id}
      >
        <div
          className="card mb-3"
          style={{ maxWidth: 'auto' }}
        >
          <div className="row no-gutters">
            <div
              className="col-md-6"
              style={{ backgroundColor: 'rgba(0,0,0,.03)' }}
            >
              <div className="card-body">
                <h5 className="card-title">{nombre}</h5>
                <h6 className="card-subtitle mb-2 text-muted">
                  {hitsVariable} {descripcionVariable}
                </h6>

                {esquema === 'licencia' && (
                  <Form.Group controlId="tipo_pago">
                    <Form.Check
                      type="radio"
                      name={id}
                      label="Pagar mensualmente"
                      value={`pago_mensual_${id}`}
                      checked={tipoPago === `pago_mensual_${id}`}
                      onChange={this.handleOnChange}
                    />

                    <Form.Check
                      type="radio"
                      name={id}
                      label="Pagar anualmente"
                      value={`pago_anualizado_${id}`}
                      checked={tipoPago === `pago_anualizado_${id}`}
                      onChange={this.handleOnChange}
                    />
                  </Form.Group>
                )}

                <Link
                  to={`/cuenta/paquetes/${id}?licencia=${pago}`}
                  className="mr-3"
                >
                  <Button variant="primary">Compra en línea</Button>
                </Link>

                <Link
                  to={`/cuenta/paquetes/${id}/transferencia?licencia=${pago}`}
                  className="mr-3"
                >
                  <Button
                    type="button"
                    variant="secondary"
                  >
                    Pago con transferencia
                  </Button>
                </Link>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card-body text-right">
                <h5 className="card-title">
                  {costo > 0 ? (
                    <>
                      <span className="text-danger h4">${pago_anual ? costo_anual : costo_mensual}</span>
                      <span className="h6"> + IVA</span>
                    </>
                  ) : (
                    <span className="text-danger h4">${costo}</span>
                  )}
                </h5>

                <h6 className="card-subtitle mb-2 text-muted">
                  {esquema === 'licencia' ? (pago_anual ? 'Anual' : 'Mensual') : ''}
                </h6>

                <span className="card-text">
                  <small className="text-muted text-break">{metadata?.comercial?.detalle}</small>

                  <br />
                  <span className="font-weight-bold">
                    <h6 className="card-subtitle">
                      <span className="text-muted">
                        <del> {metadata?.comercial?.descuento_max}</del>
                      </span>{' '}
                      {metadata?.comercial?.descuento_min}
                    </h6>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  render() {
    const { error, paquetes, busy } = this.state;

    if (!!busy) {
      return <Loading className="text-info pl-3" />;
    }

    return (
      <>
        {!!error && <Redirect to="/bridge" />}

        <Tabs
          className="justify-content-center"
          variant="pills"
          defaultActiveKey="hits"
        >
          <Tab
            tabClassName="border rounded-pill"
            eventKey="hits"
            title="Paquetes de hits"
          >
            {paquetes
              .filter((item) => {
                return item.esquema === 'hits';
              })
              .map(this.renderItem)}
          </Tab>
          <Tab
            tabClassName="border rounded-pill"
            eventKey="licencia"
            title="Licencias"
          >
            {paquetes
              .filter((item) => {
                return item.esquema === 'licencia';
              })
              .map(this.renderItem)}
          </Tab>
        </Tabs>
      </>
    );
  }
}

export default Paquetes;
